import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Dev-harness only (tree-shaken out of production builds). Mimics the global
 * CSS customer websites ship — a customer's `.block { padding: 110px 32px }`
 * rule broke the calendar grid (BENG-4418) — so any Booking Engine element
 * that still carries a bare, un-namespaced class name shows up here with a red
 * outline or a broken layout instead of on a customer's site.
 *
 * Opt-in: open the harness with `?hostile-css` in the URL. Some bare classes
 * outside the calendar are still pending a rename (see the follow-ups on
 * BENG-4418), so leaving it always on would paint unrelated UI red.
 */
export const HostileHostStyles = () => {
    // The webpack `mode` define is the only reliable dev/prod signal in the
    // immersive bundle (`system.nodeEnv` is hardcoded to production there), and
    // it is what lets terser drop this fixture from production builds.
    // eslint-disable-next-line no-process-env
    if (process.env.NODE_ENV === 'production') {
        return null;
    }
    if (!new URLSearchParams(window.location.search).has('hostile-css')) {
        return null;
    }
    return (_jsx("style", { children: `
      .block { max-width: 1440px; margin: 0 auto; padding: 110px 32px; }
      .day, .today, .before, .checkin, .checkout, .range, .soft-block,
      .calendar-row, .calendar-days, .month-container, .nav-buttom,
      .wrapper, .box, .images, .image-grid, .header, .footer, .content,
      .row, .container, .card, .button, .title, .label { outline: 4px dashed red; }
    ` }));
};
